<ion-list
  mode="ios"
  lines="none"
  class="list-how"
  [ngStyle]="{'border-top': '7px solid var(--ion-color-' + how.color + ')' }"
>
  <ion-item lines="none" mode="md" color="white">
    <ion-label mode="md" color="status-icon-enable" class="font-weight-600">
      {{ how.title | translate }}
    </ion-label>
  </ion-item>

  <ion-item lines="none" mode="md" color="white">
    <ion-label mode="md" color="grayDemon">
      <ng-container *ngFor="let item of how.content | slice: 0:2">
        <p class="labels-content">{{ 'Labels.' + item | translate }}</p>
      </ng-container>
    </ion-label>
  </ion-item>

  <ng-container *ngFor="let item of how.content | slice: 2:how.content.length">
    <ion-item lines="none" mode="md" color="white">
      <ion-label mode="md" color="grayDemon">
        <p class="labels-content">{{ 'Labels.' + item | translate }}</p>
      </ion-label>
    </ion-item>
  </ng-container>

  <ion-item lines="none" mode="md" color="white" class="ion-margin-bottom">
    <ion-label mode="md" color="danger" class="labels-content">
      {{ 'Labels.availability-promotions-subject-change' | translate }}
    </ion-label>
  </ion-item>

  <ion-item lines="none" mode="md" color="white">
    <ion-button
      mode="md"
      color="tpcta"
      size="default"
      expand="block"
      (click)="onConfirm()"
      class="enderstood"
    >
      <ion-label mode="md">
        {{ "Buttons.enderstood" | translate }}
      </ion-label>
    </ion-button>
  </ion-item>
</ion-list>
